module.exports = __webpack_public_path__ + "static/img/2.d2a23fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/2.png
// module id = ZjJ/
// module chunks = 0